import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import * as APITypes from "~/API";

export const ReviewStatusTag = ({
  status,
}: {
  status: APITypes.ServiceRequestStatusType;
}) => {
  const { t } = useTranslation();
  let color = "blue";
  let icon = <SyncOutlined />;
  let statusText = t("Running");

  if (status === APITypes.ServiceRequestStatusType.Upvoted) {
    icon = <CheckCircleOutlined />;
    statusText = t("Upvoted");
  }
  if (status === APITypes.ServiceRequestStatusType.Canceled) {
    color = "yellow";
    icon = <StopOutlined />;
    statusText = t("Cancelled");
  }
  if (status === APITypes.ServiceRequestStatusType.Rejected) {
    color = "red";
    icon = <CloseCircleOutlined />;
    statusText = t("Rejected");
  }
  if (status === APITypes.ServiceRequestStatusType.Approved) {
    color = "green";
    icon = <CheckCircleOutlined />;
    statusText = t("Approved");
  }
  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
